import React from "react";

import AcademicHome from "./academicHome";

function Portfolio() {
  return <AcademicHome />;
}

export default Portfolio;